"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = CostInvoicesSearch;
const react_1 = __importStar(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const FilterableTable_1 = __importDefault(require("../../View/Resultsets/FilterableTable/FilterableTable"));
const CostInvoicesFilterBody_1 = require("./CostInvoicesFilterBody");
const CostInvoicesController_1 = require("./CostInvoicesController");
const Tools_1 = __importDefault(require("../../React/Tools/Tools"));
const ToolsDate_1 = __importDefault(require("../../React/Tools/ToolsDate"));
const CostInvoicesBadges_1 = require("./CostInvoicesBadges");
require("./CostInvoicesSearch.css");
function CostInvoicesSearch({ title }) {
    const [isSyncing, setIsSyncing] = (0, react_1.useState)(false);
    const [syncError, setSyncError] = (0, react_1.useState)(null);
    const [syncSuccess, setSyncSuccess] = (0, react_1.useState)(null);
    const [syncWarnings, setSyncWarnings] = (0, react_1.useState)([]);
    const [showSyncModal, setShowSyncModal] = (0, react_1.useState)(false);
    const [syncType, setSyncType] = (0, react_1.useState)("INCREMENTAL");
    const [dateFrom, setDateFrom] = (0, react_1.useState)("");
    const [dateTo, setDateTo] = (0, react_1.useState)("");
    const [reparseEnabled, setReparseEnabled] = (0, react_1.useState)(false);
    const [showReparseModal, setShowReparseModal] = (0, react_1.useState)(false);
    const [reparseLoading, setReparseLoading] = (0, react_1.useState)(false);
    const [reparseError, setReparseError] = (0, react_1.useState)(null);
    const [reparseSuccess, setReparseSuccess] = (0, react_1.useState)(null);
    const [reparsePreview, setReparsePreview] = (0, react_1.useState)([]);
    const [reparseSelection, setReparseSelection] = (0, react_1.useState)(new Set());
    const REPARSE_TOOL_FLAG = "costInvoicesReparseTool";
    (0, react_1.useEffect)(() => {
        document.title = title;
    }, [title]);
    (0, react_1.useEffect)(() => {
        setReparseEnabled(sessionStorage.getItem(REPARSE_TOOL_FLAG) === "1");
    }, []);
    const toNumber = (value) => {
        if (typeof value === "number")
            return value;
        if (typeof value === "string") {
            const parsed = Number(value.replace(",", "."));
            return Number.isNaN(parsed) ? 0 : parsed;
        }
        return 0;
    };
    const formatDate = (value) => {
        if (!value)
            return "-";
        return ToolsDate_1.default.dateYMDtoDMY(value);
    };
    const formatAmount = (value, currency) => `${Tools_1.default.formatNumber(toNumber(value))} ${currency || "PLN"}`;
    /**
     * Synchronizacja faktur z KSeF
     */
    const handleSync = (0, react_1.useCallback)(async () => {
        setIsSyncing(true);
        setSyncError(null);
        setSyncSuccess(null);
        setSyncWarnings([]);
        setShowSyncModal(false);
        try {
            const params = {
                syncType,
            };
            if (syncType === "VERIFICATION") {
                if (!dateFrom || !dateTo) {
                    throw new Error("Dla weryfikacji wymagane są daty od i do");
                }
                params.dateFrom = dateFrom;
                params.dateTo = dateTo;
            }
            const result = await (0, CostInvoicesController_1.syncFromKsef)(params);
            const imported = result.data.imported ?? 0;
            const alreadyAdded = result.data.alreadyAdded ?? 0;
            const failedCount = result.data.failedCount ?? 0;
            const errors = result.data.errorDetails || [];
            setSyncSuccess(result.message ||
                `Synchronizacja zakończona: ${imported} zaimportowanych, ${alreadyAdded} już dodane${failedCount > 0 ? `, ${failedCount} błędne` : ""}`);
            if (failedCount > 0 && errors.length > 0) {
                setSyncWarnings(errors);
            }
            // Odśwież listę faktur
            await CostInvoicesController_1.costInvoicesRepository.loadItemsFromServerPOST([]);
        }
        catch (error) {
            setSyncError(error instanceof Error ? error.message : "Błąd synchronizacji z KSeF");
        }
        finally {
            setIsSyncing(false);
        }
    }, [syncType, dateFrom, dateTo]);
    const hideReparseTool = () => {
        sessionStorage.removeItem(REPARSE_TOOL_FLAG);
        setReparseEnabled(false);
        setShowReparseModal(false);
        setReparsePreview([]);
        setReparseSelection(new Set());
    };
    const refreshReparsePreview = (0, react_1.useCallback)(async () => {
        setReparseLoading(true);
        setReparseError(null);
        setReparseSuccess(null);
        try {
            const result = await (0, CostInvoicesController_1.fetchCostInvoiceReparsePreview)();
            const invoices = result.invoices || [];
            setReparsePreview(invoices);
            setReparseSelection(new Set(invoices.map((item) => item.id)));
        }
        catch (error) {
            setReparseError(error instanceof Error ? error.message : "Błąd podglądu reparse");
        }
        finally {
            setReparseLoading(false);
        }
    }, []);
    const openReparseModal = async () => {
        setShowReparseModal(true);
        await refreshReparsePreview();
    };
    const toggleReparseSelection = (id) => {
        setReparseSelection((prev) => {
            const next = new Set(prev);
            if (next.has(id)) {
                next.delete(id);
            }
            else {
                next.add(id);
            }
            return next;
        });
    };
    const handleApplyReparse = async () => {
        if (reparseSelection.size === 0)
            return;
        setReparseLoading(true);
        setReparseError(null);
        setReparseSuccess(null);
        try {
            const ids = Array.from(reparseSelection);
            const result = await (0, CostInvoicesController_1.applyCostInvoiceReparse)(ids);
            setReparseSuccess(`Zastosowano reparse: ${result.updated} zaktualizowanych, ${result.errors.length} błędów`);
            await CostInvoicesController_1.costInvoicesRepository.loadItemsFromServerPOST([]);
            await refreshReparsePreview();
        }
        catch (error) {
            setReparseError(error instanceof Error ? error.message : "Błąd zastosowania reparse");
        }
        finally {
            setReparseLoading(false);
        }
    };
    function renderInvoiceCard(invoice, isActive) {
        void isActive;
        const notes = invoice.notes?.trim();
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: "cost-invoice-card__header" },
                react_1.default.createElement("div", null,
                    react_1.default.createElement("div", { className: "cost-invoice-card__number" }, invoice.invoiceNumber || "-"),
                    react_1.default.createElement("div", { className: "cost-invoice-card__supplier" }, invoice.supplierName || "Brak dostawcy"),
                    react_1.default.createElement("div", { className: "cost-invoice-card__meta" },
                        "NIP: ",
                        invoice.supplierNip || "-",
                        invoice.supplierAddress ? ` | ${invoice.supplierAddress}` : "")),
                react_1.default.createElement("div", { className: "cost-invoice-card__status-wrap" },
                    react_1.default.createElement(CostInvoicesBadges_1.InvoiceTypeBadge, { invoiceType: invoice.invoiceType }),
                    react_1.default.createElement(CostInvoicesBadges_1.PaymentStatusBadge, { status: invoice.paymentStatus, paidAmount: invoice.paidAmount, grossAmount: toNumber(invoice.grossAmount) }),
                    react_1.default.createElement(CostInvoicesBadges_1.PaymentMethodBadge, { paymentMethod: invoice.paymentMethod }))),
            react_1.default.createElement("div", { className: "cost-invoice-card__body" },
                react_1.default.createElement("div", { className: "cost-invoice-card__dates" },
                    react_1.default.createElement("div", { className: "cost-invoice-card__date-item" },
                        react_1.default.createElement("div", { className: "cost-invoice-card__label" }, "Data wyst."),
                        react_1.default.createElement("div", { className: "cost-invoice-card__value" }, formatDate(invoice.issueDate))),
                    react_1.default.createElement("div", { className: "cost-invoice-card__date-item" },
                        react_1.default.createElement("div", { className: "cost-invoice-card__label" }, "Data sprzed."),
                        react_1.default.createElement("div", { className: "cost-invoice-card__value" }, formatDate(invoice.saleDate))),
                    react_1.default.createElement("div", { className: "cost-invoice-card__date-item" },
                        react_1.default.createElement("div", { className: "cost-invoice-card__label" }, "Termin plat."),
                        react_1.default.createElement("div", { className: "cost-invoice-card__value" }, formatDate(invoice.dueDate))),
                    invoice.paymentDate && (react_1.default.createElement("div", { className: "cost-invoice-card__date-item" },
                        react_1.default.createElement("div", { className: "cost-invoice-card__label" }, "Data zapl."),
                        react_1.default.createElement("div", { className: "cost-invoice-card__value cost-invoice-card__value--paid" }, formatDate(invoice.paymentDate))))),
                react_1.default.createElement("div", { className: "cost-invoice-card__amounts" },
                    react_1.default.createElement("div", { className: "cost-invoice-card__gross" }, formatAmount(invoice.grossAmount, invoice.currency)),
                    react_1.default.createElement("div", { className: "cost-invoice-card__amount-detail" },
                        "Netto: ",
                        formatAmount(invoice.netAmount, invoice.currency)),
                    react_1.default.createElement("div", { className: "cost-invoice-card__amount-detail" },
                        "VAT: ",
                        formatAmount(invoice.vatAmount, invoice.currency)))),
            react_1.default.createElement("div", { className: "cost-invoice-card__bottom" },
                react_1.default.createElement("div", { className: "cost-invoice-card__tags" }, notes && (react_1.default.createElement("span", { className: "badge bg-secondary-subtle text-secondary-emphasis" },
                    "Notatka: ",
                    notes))),
                react_1.default.createElement("div", { className: "cost-invoice-card__footer" },
                    react_1.default.createElement("span", { className: "cost-invoice-card__label" }, "KSeF:"),
                    react_1.default.createElement("code", { className: "cost-invoice-card__ksef" }, invoice.ksefNumber || "-")))));
    }
    // Przycisk synchronizacji KSeF jako dodatkowy przycisk w nagłówku
    const SyncKsefButton = () => (react_1.default.createElement(react_bootstrap_1.Button, { variant: "outline-primary", size: "sm", onClick: () => setShowSyncModal(true), disabled: isSyncing, className: "me-2" }, isSyncing ? (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_bootstrap_1.Spinner, { animation: "border", size: "sm", className: "me-1" }),
        "Synchronizacja...")) : ("Pobierz z KSeF")));
    const ReparseToolButton = () => (react_1.default.createElement(react_bootstrap_1.Button, { variant: "outline-danger", size: "sm", onClick: openReparseModal, disabled: reparseLoading, className: "me-2" }, reparseLoading ? (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_bootstrap_1.Spinner, { animation: "border", size: "sm", className: "me-1" }),
        "Reparse...")) : ("Reparse XML")));
    return (react_1.default.createElement(react_1.default.Fragment, null,
        syncError && (react_1.default.createElement(react_bootstrap_1.Alert, { variant: "danger", onClose: () => setSyncError(null), dismissible: true, className: "mx-3 mt-3" }, syncError)),
        syncSuccess && (react_1.default.createElement(react_bootstrap_1.Alert, { variant: "success", onClose: () => setSyncSuccess(null), dismissible: true, className: "mx-3 mt-3" }, syncSuccess)),
        syncWarnings.length > 0 && (react_1.default.createElement(react_bootstrap_1.Alert, { variant: "warning", onClose: () => setSyncWarnings([]), dismissible: true, className: "mx-3 mt-3" },
            react_1.default.createElement("div", { className: "fw-semibold mb-1" }, "Faktury z b\u0142\u0119dami importu:"),
            react_1.default.createElement("ul", { className: "mb-0 ps-3" }, syncWarnings.map((warning, index) => (react_1.default.createElement("li", { key: `${index}_${warning}` }, warning)))))),
        reparseError && (react_1.default.createElement(react_bootstrap_1.Alert, { variant: "danger", onClose: () => setReparseError(null), dismissible: true, className: "mx-3 mt-3" }, reparseError)),
        reparseSuccess && (react_1.default.createElement(react_bootstrap_1.Alert, { variant: "success", onClose: () => setReparseSuccess(null), dismissible: true, className: "mx-3 mt-3" }, reparseSuccess)),
        react_1.default.createElement("div", { className: "cost-invoices-search" },
            react_1.default.createElement(FilterableTable_1.default, { id: "costInvoices", title: title, FilterBodyComponent: CostInvoicesFilterBody_1.CostInvoicesFilterBody, tableStructure: [
                    { header: undefined, renderTdBody: renderInvoiceCard },
                ], AddNewButtonComponents: reparseEnabled ? [SyncKsefButton, ReparseToolButton] : [SyncKsefButton], isDeletable: false, isCopyable: false, repository: CostInvoicesController_1.costInvoicesRepository, selectedObjectRoute: "/cost-invoice/" })),
        react_1.default.createElement(react_bootstrap_1.Modal, { show: showSyncModal, onHide: () => setShowSyncModal(false) },
            react_1.default.createElement(react_bootstrap_1.Modal.Header, { closeButton: true },
                react_1.default.createElement(react_bootstrap_1.Modal.Title, null, "Synchronizacja z KSeF")),
            react_1.default.createElement(react_bootstrap_1.Modal.Body, null,
                react_1.default.createElement(react_bootstrap_1.Form.Group, { className: "mb-3" },
                    react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Typ synchronizacji"),
                    react_1.default.createElement(react_bootstrap_1.Form.Select, { value: syncType, onChange: (e) => setSyncType(e.target.value) },
                        react_1.default.createElement("option", { value: "INCREMENTAL" }, "Przyrostowa (od ostatniej synchronizacji)"),
                        react_1.default.createElement("option", { value: "VERIFICATION" }, "Weryfikacyjna (zakres dat)")),
                    react_1.default.createElement(react_bootstrap_1.Form.Text, { className: "text-muted" }, syncType === "INCREMENTAL"
                        ? "Pobiera nowe faktury od ostatniej synchronizacji"
                        : "Pobiera faktury z podanego zakresu dat (do weryfikacji kompletności)")),
                syncType === "VERIFICATION" && (react_1.default.createElement(react_bootstrap_1.Row, null,
                    react_1.default.createElement(react_bootstrap_1.Col, null,
                        react_1.default.createElement(react_bootstrap_1.Form.Group, { className: "mb-3" },
                            react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Data od"),
                            react_1.default.createElement(react_bootstrap_1.Form.Control, { type: "date", value: dateFrom, onChange: (e) => setDateFrom(e.target.value), required: true }))),
                    react_1.default.createElement(react_bootstrap_1.Col, null,
                        react_1.default.createElement(react_bootstrap_1.Form.Group, { className: "mb-3" },
                            react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Data do"),
                            react_1.default.createElement(react_bootstrap_1.Form.Control, { type: "date", value: dateTo, onChange: (e) => setDateTo(e.target.value), required: true })))))),
            react_1.default.createElement(react_bootstrap_1.Modal.Footer, null,
                react_1.default.createElement(react_bootstrap_1.Button, { variant: "secondary", onClick: () => setShowSyncModal(false) }, "Anuluj"),
                react_1.default.createElement(react_bootstrap_1.Button, { variant: "primary", onClick: handleSync, disabled: syncType === "VERIFICATION" && (!dateFrom || !dateTo) }, "Synchronizuj"))),
        react_1.default.createElement(react_bootstrap_1.Modal, { show: showReparseModal, onHide: () => setShowReparseModal(false), size: "lg" },
            react_1.default.createElement(react_bootstrap_1.Modal.Header, { closeButton: true },
                react_1.default.createElement(react_bootstrap_1.Modal.Title, null, "Reparse XML - podgl\u0105d zmian")),
            react_1.default.createElement(react_bootstrap_1.Modal.Body, null,
                react_1.default.createElement("div", { className: "d-flex justify-content-between align-items-center mb-3" },
                    react_1.default.createElement("div", { className: "text-muted" }, "Wybierz faktury do zastosowania zmian. Pozycje (_items) nie s\u0105 modyfikowane."),
                    react_1.default.createElement(react_bootstrap_1.Button, { variant: "outline-secondary", size: "sm", onClick: hideReparseTool }, "Ukryj narz\u0119dzie")),
                reparseLoading ? (react_1.default.createElement("div", { className: "text-center py-4" },
                    react_1.default.createElement(react_bootstrap_1.Spinner, { animation: "border" }))) : reparsePreview.length === 0 ? (react_1.default.createElement(react_bootstrap_1.Alert, { variant: "info" }, "Brak faktur ze zmianami.")) : (react_1.default.createElement(react_bootstrap_1.Table, { striped: true, bordered: true, hover: true, size: "sm" },
                    react_1.default.createElement("thead", null,
                        react_1.default.createElement("tr", null,
                            react_1.default.createElement("th", { style: { width: 40 } },
                                react_1.default.createElement(react_bootstrap_1.Form.Check, { type: "checkbox", checked: reparseSelection.size === reparsePreview.length, onChange: (event) => {
                                        const next = event.target.checked
                                            ? new Set(reparsePreview.map((item) => item.id))
                                            : new Set();
                                        setReparseSelection(next);
                                    } })),
                            react_1.default.createElement("th", null, "Nr faktury"),
                            react_1.default.createElement("th", null, "KSeF"),
                            react_1.default.createElement("th", null, "Liczba zmian"))),
                    react_1.default.createElement("tbody", null, reparsePreview.map((item) => (react_1.default.createElement("tr", { key: item.id },
                        react_1.default.createElement("td", null,
                            react_1.default.createElement(react_bootstrap_1.Form.Check, { type: "checkbox", checked: reparseSelection.has(item.id), onChange: () => toggleReparseSelection(item.id) })),
                        react_1.default.createElement("td", null, item.invoiceNumber || "-"),
                        react_1.default.createElement("td", null, item.ksefNumber || "-"),
                        react_1.default.createElement("td", null, Object.keys(item.changes || {}).length))))))),
                reparsePreview.length > 0 && reparseSelection.size > 0 && (react_1.default.createElement("div", { className: "mt-3" },
                    react_1.default.createElement("div", { className: "fw-semibold" }, "Podgl\u0105d zmian (pierwsza wybrana faktura):"),
                    (() => {
                        const firstId = Array.from(reparseSelection)[0];
                        const current = reparsePreview.find((item) => item.id === firstId);
                        if (!current)
                            return null;
                        return (react_1.default.createElement(react_bootstrap_1.Table, { striped: true, bordered: true, size: "sm", className: "mt-2" },
                            react_1.default.createElement("thead", null,
                                react_1.default.createElement("tr", null,
                                    react_1.default.createElement("th", null, "Pole"),
                                    react_1.default.createElement("th", null, "Przed"),
                                    react_1.default.createElement("th", null, "Po"))),
                            react_1.default.createElement("tbody", null, Object.entries(current.changes || {}).map(([key, value]) => (react_1.default.createElement("tr", { key: key },
                                react_1.default.createElement("td", null, key),
                                react_1.default.createElement("td", null, String(value.before ?? "")),
                                react_1.default.createElement("td", null, String(value.after ?? ""))))))));
                    })()))),
            react_1.default.createElement(react_bootstrap_1.Modal.Footer, null,
                react_1.default.createElement(react_bootstrap_1.Button, { variant: "secondary", onClick: () => setShowReparseModal(false) }, "Zamknij"),
                react_1.default.createElement(react_bootstrap_1.Button, { variant: "primary", onClick: handleApplyReparse, disabled: reparseLoading || reparseSelection.size === 0 }, "Zastosuj zmiany")))));
}
